import React, { useEffect, useState } from 'react';

const pad2 = (value) => String(Math.max(0, value)).padStart(2, '0');

export default function Blocker({ user, onNavigate, targetDate }) {
  const calculateTimeLeft = () => {
    if (!targetDate) {
      return {
        hours: '00',
        minutes: '00',
        seconds: '00',
      };
    }

    const diff = new Date(targetDate).getTime() - Date.now();

    if (diff <= 0) {
      return {
        hours: '00',
        minutes: '00',
        seconds: '00',
      };
    }

    const totalSeconds = Math.floor(diff / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      hours: pad2(hours),
      minutes: pad2(minutes),
      seconds: pad2(seconds),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());

    if (!targetDate) return;

    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100dvh',
        overflow: 'hidden',
        padding: '24px 16px 24px',
        boxSizing: 'border-box',
        color: '#fff',
        textAlign: 'center',
        background: "url('/mytapisbg.png') center / cover no-repeat",
        zIndex: 9999,
      }}
    >


    <div
      style={{ position: 'fixed', width: '100%', top: 0, left: 0, zIndex: 50}}
      aria-label="Version 1.0"
    >
      <img src="/v2/splash_top.png" style={{borderBottom: "3px solid #6a2306", display: "block", position: "relative", width: "100%", zIndex: 2}}/>
    </div>

    <div
      style={{ position: 'fixed', width: '100%', bottom: 0, left: 0, zIndex: 50}}
      aria-label="Version 1.0"
    >
      <img src="/v2/splash_bottom.png" style={{display: "block", position: "relative", marginBottom: "-3px", width: "100%"}}/>
    </div>

<div
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',    
    padding: '100px 16px 120px',
    boxSizing: 'border-box',
    pointerEvents: 'auto',
  }}
>

      <div className="shadow2" style={{ fontFamily: '"Fredoka", sans-serif',fontWeight: 600, marginTop: 0, color: "#FFF", fontSize: 24}}>
        PREPARING FOR
      </div>


<div className="shadow2" style={{ fontFamily: '"Fredoka", sans-serif',fontWeight: 600, marginTop: 0, color: "#FFE100", fontSize: 28}}>
        SEASON 3
      </div>

      <div className="shadow2" style={{ marginTop: 10, fontFamily: '"Fredoka", sans-serif', color: "#FFF", fontSize: 21, marginBottom: 20, fontWeight: 600}}>
        The Sands of Time are shifting!
      </div>

      <div
  style={{
    marginTop: 10,
    width: "100%",
    maxWidth: 280,
    aspectRatio: "358 / 366",
    backgroundImage: 'url("/v2/preparing.png")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "100% 100%",
    fontFamily: '"Fredoka", sans-serif',
    padding: 20,
    marginBottom: 20,
    boxSizing: "border-box",
    lineHeight: "21px",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
  <div
    style={{
      fontWeight: 600,
      fontSize: 18,
      color: "#1A0101",
    }}
  >
    SEASON 2 HAS OFFICIALLY CONCLUDED.
  </div>

  <div
    style={{
      marginTop: 10,
      fontWeight: 600,
      fontSize: 18,
      color: "#D71717",
    }}
  >
    We are currently taking a snapshot of all players progress.
  </div>

  <div
    style={{
      marginTop: 10,
      fontWeight: 600,
      fontSize: 17,
      color: "#54240F",
    }}
  >
    Your efforts, Runes, Sparks, Cards and more progression are being calculated
    to determine your $TAPI Points and your Season 3 Starter Pack.
  </div>
</div>

      <div className="shadow1" style={{ marginTop: 20, fontFamily: '"Fredoka", sans-serif',fontWeight: 600, marginTop: "0px", paddingBottom: 5, color: "#FFF", fontSize: 18}}>
        SEASON 3 BEGINS IN:
      </div>

      <div style={{ fontFamily: '"Fredoka", sans-serif',fontWeight: 600,display: "inline-block", position: "relative", width: 250, height: 83 }}>
        <img src="/ticker.png" style={{ width: 250, height: 83 }} alt="" />

        <div
          className="hour"
          style={{
            lineHeight: "70px",
            fontSize: "24px",
            top: 8,
            left: 0,
            position: "absolute",
            width: 70,
            height: 70,
          }}
        >
          {timeLeft.hours}
        </div>

        <div
          className="minute"
          style={{
            lineHeight: "70px",
            fontSize: "24px",
            top: 8,
            left: "calc(50% - 35px)",
            position: "absolute",
            width: 70,
            height: 70,
          }}
        >
          {timeLeft.minutes}
        </div>

        <div
          className="second"
          style={{
            lineHeight: "70px",
            fontSize: "24px",
            top: 8,
            right: 0,
            position: "absolute",
            width: 70,
            height: 70,
          }}
        >
          {timeLeft.seconds}
        </div>
      </div>

      <img
        src="/v2/learnmore.png"
        style={{ display: "none", width: 170, marginTop: 15, height: 80, cursor: "pointer" }}
        alt="Learn more"
        onClick={() => {
          if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.openLink(
              "https://medium.com/@taptopia/taptopia-season-2-the-legend-of-the-scars-ada9e605b39e"
            );
          } else {
            window.open(
              "https://medium.com/@taptopia/taptopia-season-2-the-legend-of-the-scars-ada9e605b39e",
              "_blank"
            );
          }
        }}
      />
      
    </div></div>
  );
}